module.exports = __webpack_public_path__ + "static/media/devicesIcon.2efdd8dc.svg";